module.exports = __webpack_public_path__ + "static/savings-oga-bfafa8f258904fccfcf270dc542ae97e.png";